<template>
  <div>
    <van-nav-bar
      title="提供新手机号码"
      left-text="返回"
      left-arrow
      @click-left="goback()"
    />
    <div class="MyCenter">
      <b-row>
        <b-col cols="12">
          <b-form-group class="col-md-2 mb-3" label="新手机号">
            <b-form-input placeholder="请输入新手机号"></b-form-input>
          </b-form-group>
          <b-form-group class="col-md-2 mb-3" label="验证码">
            <b-form-input placeholder="请输入验证码"></b-form-input>
          </b-form-group>
          <b-form-group>
            <b-button variant="primary btn-block" class="">确认</b-button>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "changeMail",
  components: {},
  data() {
    return {};
  },
  methods: {
    goback() {
      var $this = this;
      $this.$router.go(-2);
    },
  },
};
</script>
